import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import "./index.css"

import SmartSearchImg from "../../../images/smart_search.png"
import VPRupeeImg from "../../../images/vp_rupee.jpg"

import { CheckboxField, Table } from "../../../helpers";
import Button from "../../../helpers/Button";
import Menu from "../../../helpers/Menu"

import { Tooltip } from "primereact/tooltip";
import { Sidebar } from "primereact/sidebar";

import Loading from "../../../common/Loading";
import PIPunchModal from "./Components/PIPunchModal"
import DispatchDetailsDisplay from "../../../common/DispatchDetailsDisplay";
import ButtonGroup from "../../../common/ButtonGroup";
import PMUserName from "../../../common/PMUserName";
import CopyToClipboard from "../../../common/CopyToClipboard";

import { 
    getDateString, 
    getCompanyShortName, 
    getFullName,
    getMobileNumber,
    getMinAndMaxDateRange,
    isMobile
} from "../../../utils";

import Search from "./Components/Search";

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { setSelectedSellerPO } from "../../../services/redux/reducers/inward/inward";
import { fetchSellerPOs, fetchPIPunch, fetchMaterialsData, setInitialLoad, updateSearchParams, updateIsSmartSearch, setIsSearchVisible } from "../../../services/redux/reducers/inward/inward";
import { fetchCompanySupplyType, fetchIncoTerms } from "../../../services/redux/reducers/commonThunk";

import { getSellerPOItemsBySellerPOIds } from "../../../services/api/sellerPOItem";
import { getWarehouseStatus } from "../../../services/api/warehouseStatusDetails";


const Inward = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [selectedSellerPOs, setSelectedSellerPOs] = useState([])
    const [dataType, setDataType] = useState("inwardData")
    const [visiblePIPunch, setVisiblePIPunch] = useState(false)
    const [selectedReq, setSelectedReq] = useState({})
    const [sellerPOItems, setSellerPOItems] = useState([])
    const [selectedWarehouse, setSelectedWarehouse] = useState(null)
    const [warehouseStatus, setWarehouseStatus] = useState({})
    const [userRelatedWarehouses, setUserRelatedWarehouses] = useState([])
    const [currentWarehouse, setCurrentWarehouse] = useState("")
    const [isWarehouseEditable, setIsWarehouseEditable] = useState(false)

    const materialProductsData = useSelector(state => state.inward.materialProductsData)
    const userDetails = useSelector(state => state.userDetails)
    const userId = useSelector((state) => state.userDetails.userId)
    const companyBranches = useSelector(state => state.userDetails.PMCompanyDetails.companyBranches)
    const piPunchData = useSelector(state => state.inward.piPunchData)
    const piPunchLoading = useSelector(state => state.inward.piPunchLoading)
    const isSearchVisible = useSelector(state => state.inward.isSearchVisible)
    const isSearchActive = useSelector(state => state.inward.isSearchActive)
    const isPageLoading = useSelector(state => state.inward.loading)
    const isInitialLoad = useSelector(state => state.inward.isInitialLoad)
    const searchParams = useSelector(state => state.inward.searchParams)
    const paginationParams = useSelector(state => state.inward.paginationParams)
    const sellerPOsData = useSelector(state => state.inward.sellerPOsData)
    const selectedSellerPOId = useSelector(state => state.inward.selectedSellerPO)
    const isSmartSearch = useSelector(state => state.inward.isSmartSearch)
    const companyWarehouses = useSelector(state => state.userDetails.PMCompanyDetails.companyWarehouses)
    const companyPmBranches = useSelector(state => state.userDetails.PMCompanyDetails.companyPmBranches)
    const userRoleList = useSelector(state => state.userDetails.rolesList)
    const incoTerms = useSelector((state) => state.common.incoTerms)

    
    const actionMenu = useRef(null)
    const dispatch = useDispatch()

    const isMobileDevice = isMobile()

    useEffect(() => {
        dispatch(fetchCompanySupplyType())
        dispatch(fetchIncoTerms())
        getIntialLoadData()

    }, [])

    useEffect(() => {
        if (sellerPOsData && sellerPOsData.length > 0) {
            let buyerReqIds = sellerPOsData.map(eachSellerPO => eachSellerPO.buyerReqId)

            let data = {
                buyerReqIds: buyerReqIds
            }

            dispatch(fetchPIPunch(data))

            const sellerPOIds = sellerPOsData.map(eachSellerPO => eachSellerPO.sellerPOId)
            getSellerPOItems(sellerPOIds)
        }
    }, [sellerPOsData])

    useEffect(() => {
        if (selectedWarehouse && !isWarehouseEditable){
            getWarehouseStatusDetails()
        }
    }, [selectedWarehouse])
    
    useEffect(()=>{
        if(companyWarehouses){
            const relatedPmBranchIds = userRoleList?.map(each => each.branchId)
            const allIndiaLevelBranchId = 0
            let relatedCompanyWarehouse = []

            if(relatedPmBranchIds.includes(allIndiaLevelBranchId)){
                relatedCompanyWarehouse = companyWarehouses
            }else{
                const relatedWarehouseIds = companyPmBranches.filter(each => relatedPmBranchIds.includes(each.branchId))?.map(each => each.warehouseId)
                relatedCompanyWarehouse = companyWarehouses.filter(each => relatedWarehouseIds.includes(each.warehouseId))
            }
            relatedCompanyWarehouse = relatedCompanyWarehouse.filter(eachWarehouse => eachWarehouse.warehouseName !== "DUMMY")
            setUserRelatedWarehouses(relatedCompanyWarehouse)

            const activeRoleBranchId = userRoleList.find(each => each.userRoleId === userDetails.activeRoleId)?.branchId
            if(activeRoleBranchId === 0){
                setSelectedWarehouse(relatedCompanyWarehouse[0].warehouseId) // By default , active role's warehouse as selected warehouse
                setCurrentWarehouse(relatedCompanyWarehouse[0].warehouseName)  // By default , active role's warehouse as current WH

            }else{
                const relatedActiveWarehouseId = companyPmBranches.find(each => each.branchId === activeRoleBranchId)?.warehouseId
                const relatedActiveRoleWarehouse = companyWarehouses.find(each => each.warehouseId === relatedActiveWarehouseId)
                if(relatedActiveRoleWarehouse){
                    setSelectedWarehouse(relatedActiveRoleWarehouse.warehouseId) // By default , active role's warehouse as selected warehouse
                    setCurrentWarehouse(relatedActiveRoleWarehouse.warehouseName)  // By default , active role's warehouse as current WH
                }
            }
        }
    },[companyWarehouses] )

    const getIntialLoadData = () => {
        if(isInitialLoad){
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 2)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }

            dispatch(updateSearchParams(updatedSearchParams))
            dispatch(setInitialLoad(false))
        }
    }

    const getSellerPOItems = async (sellerPOIds) => {
        setIsLoading(true)
        const sellerPOItemsRes = await getSellerPOItemsBySellerPOIds(sellerPOIds)
        if (sellerPOItemsRes?.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: "Seller PO Items", detail: sellerPOItemsRes?.data?.error, life: 3000 }))
        }
        const relatedSellerPOItems = sellerPOItemsRes.data
        setSellerPOItems(relatedSellerPOItems)
        let buyerReqItemIds = relatedSellerPOItems.map(eachSellerPOItem => eachSellerPOItem.buyerReqItemId)
        let materialIdParams = {
            buyerReqItemsIds: buyerReqItemIds
        }
        dispatch(fetchMaterialsData(materialIdParams))
        setIsLoading(false)
    }


    const getWarehouseStatusDetails = async () => {
        const relatedCompanyWarehouse = companyWarehouses.find(each => each.warehouseId === selectedWarehouse)
        if (relatedCompanyWarehouse) {
            const data = {
                shipAddrId: relatedCompanyWarehouse.shipAddrId
            }
            const response = await getWarehouseStatus(data)
            if (response.failure) {
                return dispatch(raiseToast({ severity: 'error', summary: "Inward Details", detail: response.data.error, life: 3000 }))
            }
            setWarehouseStatus(response.data)
            setCurrentWarehouse(relatedCompanyWarehouse.warehouseName)
        }
    }

    const handleWarehouseInputChange = (event) => {
        setSelectedWarehouse(event.target.value)
        const relatedWarehouse = userRelatedWarehouses?.find(each => each.warehouseId === event.target.value)
        setCurrentWarehouse(relatedWarehouse?.warehouseName)
    }

    const handleSelectCheckboxItemLevel = (event, row) => {
        let relatedSellerPOItems = []
        if (selectedSellerPOs.includes(row)) {
            relatedSellerPOItems = selectedSellerPOs.filter(eachSellerPOItem => eachSellerPOItem.sellerPOId === row.sellerPOId ? false : true)
        }
        else {
            relatedSellerPOItems = [...selectedSellerPOs, row]
        }
        setSelectedSellerPOs(relatedSellerPOItems)
    }

    const getBodyCheckboxItemLevel = (row) => {
        let isDisabled = false
        if(selectedSellerPOs.length){
            isDisabled = selectedSellerPOs.includes(row) ? false : true
        }
        return (
            <div className='flex justify-content-center'>
                <CheckboxField checked={selectedSellerPOs.includes(row)} onChange={(e) => handleSelectCheckboxItemLevel(e, row)} disabled={isDisabled} />
            </div>
        )
    }

    const getBuyerPODocNoBody = (row) => {
        if (row.bPOdocNo){
            let dateString = getDateString(row.bPOcreatedAt)
            let buyerName = getFullName(row.buyerFirstName, row.buyerLastName)
            return (
                <div className="text-center">
                    <div className={`flex flex-row justify-content-center custom-tooltip-${row.buyerPOId}`}>
                        <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/buyerpo/${row.buyerPOId}`, '_blank')}>{row.bPOdocNo}</p>
                        <CopyToClipboard text={row.bPOdocNo} />
                    </div>
                    <Tooltip target={`.custom-tooltip-${row.buyerPOId}`} position="top" autoHide>
                        <>
                            <p className="m-0 mb-1">Req No. {row.buyerReqDocNo}</p>
                            <p className="m-0">Client PO Num : {row.bPOclientPONum}</p>
                        </>
                    </Tooltip>
                    <div className="date-string">{buyerName}</div>
                    <div className="date-string">{dateString} {row.buyerReqIsRouted ? `- R` :  `- NR`}</div>
                </div>
            )
        }
    }

    const getSellerPODocNoBody = (row) => {
        let dateString = getDateString(row.createdAt)
        let relatedIncoTerm = incoTerms.find(eachIncoTerm => eachIncoTerm.incoTermId === row.incoTermId)
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center'>
                    <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/sellerpo/${row.sellerPOId}`, '_blank')}>{row.docNo}</p>
                    <CopyToClipboard text={row.docNo} />
                    <a style={{cursor : "pointer"}} onClick={() => window.open(`/vendor_payment_summary/${row.sellerPOId}`, '_blank')} >
                        <img className="ml-1" src={VPRupeeImg} style={{ height: 15 }} />
                    </a>
                </div>
                <div className="date-string">
                    {dateString}
                    {relatedIncoTerm && (
                        <> (<span style={{ fontWeight: "bold" }}>{relatedIncoTerm.incoTermShortName}</span>)</>
                    )}
                </div>
            </div>
        )
    }

    const getProductBody = (row) => {
        const buyerReqId = row.buyerReqId
        let productNamesListWithDuplicates = []
        let productNamesList = []

        sellerPOItems?.filter((eachReqItem) => {
            if (eachReqItem.buyerReqId === buyerReqId) {
                materialProductsData?.find((each) => {
                    if (each.buyerReqItemId === eachReqItem.buyerReqItemId) {
                        const productName = each.productName
                        if (productNamesList.includes(productName)) {
                            productNamesListWithDuplicates.push(productName)
                        } else {
                            productNamesList.push(productName)
                        }
                    }
                })
            }
        })

        if (productNamesList.length > 0 && productNamesListWithDuplicates.length > 0) {
            const totalProductNamesStr = `${productNamesList.join(", ")}, ${productNamesListWithDuplicates.join(", ")}`
            const displayProductNameStr = `${productNamesList.slice(0, 6).join(", ")} & ${productNamesList.slice(6).length + productNamesListWithDuplicates.length} more items`

            return (
                <>
                    <Tooltip target={`.custom-tool-tip-${buyerReqId}`} position="top" autoHide className='post-req-tooltip' style={{ maxWidth: "600px" }} >
                        <p className='m-0'>{totalProductNamesStr}</p>
                    </Tooltip>
                    <p className={`custom-tool-tip-${buyerReqId}`} style={{ margin: "0px" }} >
                        {displayProductNameStr}
                    </p>
                </>
            )
        }
        return (productNamesList.length > 6 ? `${productNamesList.slice(0, 6).join(", ")} & ${productNamesList.slice(6).length} more items` : productNamesList.join(", "))
    }

    const handleCopyEmailClick = (emailId) => {
        if(emailId){
            navigator.clipboard.writeText(emailId)
            .then(() => {
                return dispatch(raiseToast({severity:'success', detail: "E-Mail Id Copied!", life: 3000}))
            })
            .catch((error) => {
                return dispatch(raiseToast({severity:'error', detail: "Can't copy E-Mail Id", life: 3000}))
            })
        }
    }

    const handlePageChange = async (e) => {
        let sellerPOParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            createdAt: 'ASC'
        }

        if(isSmartSearch){
            sellerPOParams.isSmartSearch = isSmartSearch
            sellerPOParams.dataType = searchParams.dataType
        }else{
            sellerPOParams = { ...searchParams, ...sellerPOParams }
            if (sellerPOParams.searchBy !== "all") {
                sellerPOParams[sellerPOParams.searchBy] = sellerPOParams.searchText.trim()
            }
        }

        dispatch(fetchSellerPOs({ ...sellerPOParams }))
        setSelectedSellerPOs([])
    }

    const getSellerCompanyName = (row) =>{
        let mobileNumber = row.sellerPhoneNumber
            mobileNumber = getMobileNumber(mobileNumber)

            return(
                <>
                    <div className={`custom-tool-tip-${row.userId} text-center`}>
                        <div className='flex flex-column justify-content-center'>
                            <div> {getFullName(row.sellerFirstName, row.LastName)}</div>
                            <div className='m-0' style={{fontSize:"12px"}}>
                            {`(`}
                            <span style={{ fontWeight: "bold" }}>{getCompanyShortName(row.sellerCompanyName)}</span>
                            {`)`}
                        </div>
                        </div>
                        <div className="flex flex-row justify-content-center">
                            <div style={{cursor: "pointer", marginRight: '20px'}} className={`custom-tool-tip-${row.userId}`}><i className="pi pi-envelope pl-1 doc-copy-icon" style={{cursor: "pointer"}} onClick={() => handleCopyEmailClick(row.sellerEmailId)} ></i></div>
                            <div className={`custom-tool-tip-${mobileNumber}`} style={{cursor: 'pointer'}} onClick={() => window.open(`https://wa.me/${mobileNumber}`)}>{row.sellerPhoneNumber && <i className="pi pi-whatsapp pl-1 doc-copy-icon"></i>}</div>
                        </div>
                    </div>
                    <Tooltip target={`.custom-tool-tip-${mobileNumber}`} position="top" autoHide={true}>
                        <p className="m-0">{row.sellerPhoneNumber}</p>
                    </Tooltip>
                    <Tooltip target={`.custom-tool-tip-${row.userId}`} position="top" autoHide={true}>
                        <p className="m-0">{row.sellerEmailId}</p>
                    </Tooltip>
                </>
            )
    }

    const getBuyerCompanyName = (row) => {
        if(row.buyerCompanyName){
            return getCompanyShortName(row.buyerCompanyName)
        }else{
            return "-"
        }
    }

    const getKAMNameAndCityBody = (row) => {
        let kamName = getFullName(row.kamFirstName, row.kamLastName)

        let relatedPMBranch = companyBranches?.find(eachPMBranch => eachPMBranch?.branchId === row.pmBranchId)
        if (kamName) {
            return (
                <div>
                    <div className='m-0'><PMUserName userName={kamName} userId={row.createdBy}/></div>
                    <div className='m-0' style={{ fontSize: "12px" }}>
                        {`(`}
                        <span style={{ fontWeight: "bold" }}>{relatedPMBranch?.branchName}</span>
                        {`)`}
                    </div>
                </div>
            )
        }
    }

    const handlePIPunchClick = (row) => {
        setSelectedReq({
            buyerReqId: row.buyerReqId,
            docNo: row.buyerReqDocNo, 
            createdAt: row.buyerReqCreatedAt, 
            isRouted: row.buyerReqIsRouted,
        })
        dispatch(setSelectedSellerPO(row.sellerPOId))
    }

    const piPunchTemplate = (row) => {
        const relatedSellerPOs = sellerPOsData?.data?.sellerPOs?.filter(eachSellerPO => eachSellerPO.buyerReqId === row.buyerReqId && eachSellerPO.statusId === 3)
        const relatedPIPunches = piPunchData?.data?.sellerPIPunch?.filter(eachSellerPIPunch => eachSellerPIPunch?.sellerPOId === row.sellerPOId)
        const activeSellerPIPunches = relatedPIPunches?.filter(eachSellerPIPunch => eachSellerPIPunch?.statusId === 1)
        return (
            <>
                {
                    piPunchLoading ?
                        <Button label={relatedPIPunches?.length > 0 ? relatedPIPunches?.length : "0"} style={{ width: "30px", height: "30px" }} rounded icon="pi pi-spin pi-spinner" disabled onClick={() => handlePIPunchClick({ ...row })} /> :
                        <Button label={activeSellerPIPunches?.length > 0 ? activeSellerPIPunches?.length : "0"} style={{ width: "30px", height: "30px" }} rounded disabled={relatedSellerPOs?.length === 0} onClick={() => handlePIPunchClick({ ...row })} />
                }
            </>
        )
    }

    const handleSmartSearch = () => {
        dispatch(fetchSellerPOs({ 
            ...paginationParams, 
            dataType: searchParams.dataType, 
            pageNo: 0, 
            isSmartSearch: true 
        }))
        dispatch(updateIsSmartSearch(true))
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }

    const smartSearchFilterBody = () => {
        return (
            <>
                <div className="custom-tooltip-smart-search" >
                    <img src={SmartSearchImg} style={{ height: 25, cursor: "pointer" }} onClick={handleSmartSearch} />
                </div>
                <Tooltip target=".custom-tooltip-smart-search" position="top" autoHide>
                    <p className="m-0 mb-1">Smart Search</p>
                </Tooltip>
            </>
        )
    }

    const getSellerDeliveryDateBody = (row) => {
        let relatedSellerPOItems = sellerPOItems.filter(eachSPOItem => eachSPOItem.sellerPOId === row.sellerPOId)
        let relatedSellerDeliveryDates = []
        if(relatedSellerPOItems.length){
            relatedSellerPOItems.map(eachSellerPOItem => {
                let relatedDeliveryDate = new Date(eachSellerPOItem.createdAt)
                let updateDeliveryDate = relatedDeliveryDate.getDate() + parseInt(eachSellerPOItem.leadTime)
                relatedDeliveryDate.setDate(updateDeliveryDate)
                relatedSellerDeliveryDates.push(relatedDeliveryDate)
            })
        }

        if(relatedSellerDeliveryDates.length){
            let {minDate, maxDate } = getMinAndMaxDateRange(relatedSellerDeliveryDates)
            return (
                minDate.getTime() === maxDate.getTime() ? 
                    getDateString(maxDate) 
                    : 
                    <div className="date-string float-right">
                        {`${getDateString(minDate)} - ${getDateString(maxDate)}`}
                    </div>
            )
        }

        return "-"
    }

    const getBuyerDeliveryDateBody = (row) => {

        let relatedSellerPOItems = sellerPOItems.filter(eachSPOItem => eachSPOItem.sellerPOId === row.sellerPOId)
        let relatedClientDeliveryDates = []
        if(relatedSellerPOItems.length){
            relatedSellerPOItems.map(eachSellerPOItem => {
                if(eachSellerPOItem.expectedClientDeliveryDate){
                    relatedClientDeliveryDates.push(new Date(eachSellerPOItem.expectedClientDeliveryDate))
                }
            })
        }

        if(relatedClientDeliveryDates.length){
            let {minDate, maxDate } = getMinAndMaxDateRange(relatedClientDeliveryDates)
            return (
                minDate.getTime() === maxDate.getTime() ? 
                    getDateString(maxDate) 
                    : 
                    <div className="date-string float-right">
                        {`${getDateString(minDate)} - ${getDateString(maxDate)}`}
                    </div>
            )
        }

        return "-"
    }

    const getRemarksBody = (row) => {
        let relatedSellerPOItems = sellerPOItems.filter(eachSPOItem => eachSPOItem.sellerPOId === row.sellerPOId)
        let latestFollowupRemarkSPOItem = relatedSellerPOItems.reduce((latest, current) => {
            const maxTS = current.followUpRemarksTS?.reduce((followupDateA, followupDateB) => (Date.parse(followupDateA) > Date.parse(followupDateB) ? followupDateA : followupDateB))
            const latestTS = latest ? latest.followUpRemarksTS?.reduce((followupDateA, followupDateB) => (Date.parse(followupDateA) > Date.parse(followupDateB) ? followupDateA : followupDateB)) : null

            return !latestTS || maxTS > latestTS ? current : latest;
        }, null)

        let latestFollowUpRemarks = null
        if(latestFollowupRemarkSPOItem){
            if(latestFollowupRemarkSPOItem.followUpRemarks?.length){
                let followUpRemarksLength = latestFollowupRemarkSPOItem.followUpRemarks.length
                latestFollowUpRemarks = latestFollowupRemarkSPOItem.followUpRemarks[followUpRemarksLength-1]
            }else{
                latestFollowUpRemarks = latestFollowupRemarkSPOItem.remarks
            }
        }
        
        if (latestFollowUpRemarks) {
            const remarkId = latestFollowUpRemarks.replace(/[\s./]+/g, '-').replace(/[^a-zA-Z0-9\-_]/g, '').toLowerCase()
            return (
                <div className="flex flex-column align-items-center">
                    <span style={{
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            WebkitLineClamp: 1,
                            lineHeight: '1.5em'
                        }} 
                        className={`custom-tool-tip-${remarkId}`}>
                        {latestFollowUpRemarks}
                    </span>
                    <Tooltip target={`.custom-tool-tip-${remarkId}`} position="top" autoHide={true}>
                        <p className="m-0">{latestFollowUpRemarks}</p>
                    </Tooltip>
                </div>
            )
        }

        return "-"
    }

    const tableColumns = [
        {
            header: smartSearchFilterBody,
        },
        {
            header: 'Seller PO No.',
            field: 'docNo',
            body: getSellerPODocNoBody,
            style: { textAlign: "center", minWidth: "120px"}
        },
        {
            header: 'Product',
            field: 'product',
            body: getProductBody,
            style: { textAlign: "center", minWidth: "200px"}
        },
        {
            header: 'Seller Name',
            field: 'sellerPO.companies.companyName',
            style: { textAlign: "center", minWidth: "150px"},
            body: getSellerCompanyName
        },
        {
            header: 'Buyer Name',
            field: 'buyerCompanyName',
            style: { textAlign: "center", minWidth: "150px" },
            body: getBuyerCompanyName
        },
        {
            header: 'KAM',
            field: 'kam',
            body: getKAMNameAndCityBody,
            style: { textAlign: "center", minWidth: "150px"}
        },
        {
            header: 'Buyer PO No.',
            field: 'buyerPO.docNo',
            body: getBuyerPODocNoBody,
            style: { textAlign: "center"}
        },
        {
            header: 'Seller Del. Date',
            field: 'sellerDeliveryDate',
            body: getSellerDeliveryDateBody,
            style: { textAlign: "center", minWidth: "120px"}
        },
        {
            header: 'Buyer Del. Date',
            field: 'buyerDeliveryDate',
            body: getBuyerDeliveryDateBody,
            style: { textAlign: "center"}
        },
        {
            header: 'PI Punch',
            field: 'PI Punch',
            body: piPunchTemplate
        },
        {
            header: 'Remarks',
            field: 'remarks',
            body: getRemarksBody,
            style: { textAlign: "center", minWidth: "250px" }
        }
    ]

    const actionButtons = [
        {
          icon: "pi pi-filter",
          label: "Filter",
          command: () => handleSearchTabDisplay(),
          className: isSearchActive ? "active-group-button" : ""
        },
    ]

    return (
        <div className="followup-layout flex flex-column">
            <div className="warehouse-top-container"  style={{ width: "100%"}}>
                <h4 className="my-2" style={{ minWidth: "10%"}}>INWARD DATA</h4>
                <div className="warehouse-display-container">
                    <DispatchDetailsDisplay
                        warehouseStatus={warehouseStatus}
                        currentWarehouse={currentWarehouse}
                        selectedWarehouse={selectedWarehouse}
                        userRelatedWarehouses={userRelatedWarehouses}
                        getWarehouseStatusDetails={getWarehouseStatusDetails}
                        handleWarehouseInputChange={handleWarehouseInputChange}
                        isWarehouseEditable={isWarehouseEditable}
                        setIsWarehouseEditable={setIsWarehouseEditable}
                    />
                </div>
                <div className="flex gap-2 justify-content-end mb-2 ml-1 warehouse-button-container">
                    {/* <Menu model={[]} popup menuRef={actionMenu} />
                    <Button icon="pi pi-filter" className={`h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} /> */}
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <div className='flex flex-row'>
                <div className="followup-table" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table
                                lazy
                                page={paginationParams.pageNo}
                                onPageChange={(e) => handlePageChange(e)}
                                totalRecords={paginationParams.totalRecords}
                                tableColumns={tableColumns}
                                data={sellerPOsData}
                                rows={paginationParams.recordsPerPage}
                                scrollable={"true"}
                                scrollHeight="510px"
                                paginator
                                excessPagesFound={paginationParams.excessPagesFound}
                                loading={isPageLoading}
                                dataKey="sellerPOItemId"
                            />
                        </div>
                    </div>
                </div>
                {
                    isSearchVisible && !isMobileDevice && 
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Search dataType={dataType} setDataType={setDataType} setSelectedSellerPOs={setSelectedSellerPOs} />
                        </div>
                }

                {
                    isSearchVisible && isMobileDevice && 
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))} >
                                <Search dataType={dataType} setDataType={setDataType} setSelectedSellerPOs={setSelectedSellerPOs} />
                            </Sidebar>
                        </div>
                }
            </div>
            <PIPunchModal
                selectedReq={selectedReq} 
                sellerPOId={selectedSellerPOId}
                sellerPOs={sellerPOsData}
                sellerPOItems={sellerPOItems}
                visiblePIPunch={visiblePIPunch} 
                isLoading={isLoading}
                setIsLoading={setIsLoading}
                setVisiblePIPunch={setVisiblePIPunch} 
                materialProductsData={materialProductsData}
            />
            <Loading visible={isLoading} />
        </div>
    )
}

export default Inward;